import { FC } from "react";

const Jobs: FC = () => {
    return (
        <>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 7.5C7 8.05228 6.55228 8.5 6 8.5H3C2.44772 8.5 2 8.05228 2 7.5C2 6.94772 2.44772 6.5 3 6.5H6C6.55228 6.5 7 6.94772 7 7.5ZM7 12.5C7 11.9477 6.55228 11.5 6 11.5H3C2.44772 11.5 2 11.9477 2 12.5C2 13.0523 2.44772 13.5 3 13.5H6C6.55228 13.5 7 13.0523 7 12.5ZM21.2955 17.7945C20.9058 18.1842 20.2742 18.1842 19.8845 17.7945L16.76 14.67C15.96 15.19 15.02 15.5 14 15.5C11.24 15.5 9 13.26 9 10.5C9 7.74 11.24 5.5 14 5.5C16.76 5.5 19 7.74 19 10.5C19 11.52 18.69 12.46 18.17 13.25L21.2964 16.3845C21.6851 16.7743 21.6847 17.4053 21.2955 17.7945ZM17 10.5C17 8.85 15.65 7.5 14 7.5C12.35 7.5 11 8.85 11 10.5C11 12.15 12.35 13.5 14 13.5C15.65 13.5 17 12.15 17 10.5ZM2 17.5C2 18.0523 2.44772 18.5 3 18.5H11C11.5523 18.5 12 18.0523 12 17.5C12 16.9477 11.5523 16.5 11 16.5H3C2.44772 16.5 2 16.9477 2 17.5Z"
                fill="black"
              />
            </svg>
        </>
    )
}

export default Jobs;